import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Link } from "react-router-dom";

const DocumentsDisplay = ({
  documentsUrl,
  labelStyles,
  textSty,
}: {
  documentsUrl: any; // Type can be refined based on your data structure
  labelStyles: object;
  textSty: object;
}) => {
  return (
    <Stack sx={{ width: "100%" }}>
      <Typography sx={{ ...labelStyles, mb: 0 }}>Documents:</Typography>
      {Array.isArray(documentsUrl) ? (
        documentsUrl.map((val, id) => (
          <Box key={id} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <TaskAltIcon sx={{ fontSize: "15px" }} />
            <Link to={val} target="_blank">
              <Typography sx={{ ...textSty }}>{val}</Typography>
            </Link>
          </Box>
        ))
      ) : typeof documentsUrl === "object" && documentsUrl !== null ? (
        Object.entries(documentsUrl).map(([key, value], id) => (
          <Box key={id} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <Link to={value?.toString() ?? ""} target="_blank">
              {" "}
              <Typography sx={{ ...textSty }}>
                {key.replace("_", " ")}:
              </Typography>
            </Link>
          </Box>
        ))
      ) : (
        <Typography sx={{ ...textSty }}>No documents available</Typography>
      )}
    </Stack>
  );
};

export default DocumentsDisplay;
